import React, { useEffect, useRef } from "react";
import { API_BASE_URL } from "../../constants/Constants";
import SCThumbnail from "./SCThumbnail";


// SCSeriesPanel: Collapsible panel for SC series thumbnails
const SCSeriesPanel = ({ scSeries, onSelectSeries, collapsed, setCollapsed, renderingEngineId = "ai-rendering-engine" }) => {
  const panelRef = useRef(null);
  const panelBg = "rgba(0, 0, 0, 0.6)";

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If panel is not collapsed and click is outside the panel, collapse it
      if (!collapsed && panelRef.current && !panelRef.current.contains(event.target)) {
        setCollapsed(true);
      }
    };

    // Add event listener when panel is expanded
    if (!collapsed) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [collapsed, setCollapsed]);

  return (
    <div
      ref={panelRef}
      style={{
        position: "fixed",
        top: "43px",
        left: "9px",
        height: "67%",
        width: collapsed ? 22 : 80,
        background: panelBg,
        zIndex: 10,
        transition: "width 0.3s",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}>
      <button
        style={{
          margin: 2,
          background: "#222",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          width: 18,
          height: 18,
          cursor: "pointer"
        }}
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? "Expand SC Series" : "Collapse"}
      >
        {collapsed ? "<" : ">"}
      </button>
      {!collapsed && (
        <div style={{ overflowY: "auto", width: "100%", padding: "4px 2px", flex: 1 }}>
          {scSeries && scSeries.length > 0 ? scSeries.map((series, idx) => {
            const firstImg = series.imageList && series.imageList[0];
            const thumbImageId = firstImg ? `dicomweb:${API_BASE_URL}jwtServices/study/imageWithFileSize/get/${firstImg.id}/${firstImg.thumbnailStorageKey || firstImg.imageStorageKey}` : null;
            const seriesNumber = series.seriesNumber || idx + 1;
            const imageCount = series.imageList ? series.imageList.length : 0;
            
            return (
              <div
                key={series.id}
                style={{
                  marginBottom: "3px",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  width: "100%"
                }}
                onClick={() => onSelectSeries(series)}
                draggable
                onDragStart={e => {
                  e.dataTransfer.setData("seriesId", series.id);
                  onSelectSeries(series);
                }}
                title={series.seriesDescription || `SC Series ${idx + 1}`}>
                
                {/* Thumbnail wrapper */}
                <div
                  style={{
                    background: "#111",
                    borderRadius: 4,
                    padding: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "1px",
                    width: "100%"
                  }}
                >
                  {thumbImageId ? (
                    <SCThumbnail 
                      imageId={thumbImageId} 
                      size={56} 
                      seriesName={series.seriesDescription || `SC Series ${idx + 1}`}
                      renderingEngineId={renderingEngineId}
                    />
                  ) : (
                    <div style={{ width: 50, height: 50, background: "#333", borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontSize: 8 }}>No Img</div>
                  )}
                </div>
                
                {/* Series Description */}
                <div style={{
                  color: "#C4C4C4",
                  fontSize: "6px",
                  fontWeight: "500",
                  marginBottom: "0px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                  boxSizing: "border-box"
                }}>
                  {series.seriesDescription || `SC Series ${idx + 1}`}
                </div>
                
                {/* Series Info: S number and Image count */}
                <div style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  fontSize: "5px",
                  color: "#999",
                  width: "100%",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                  boxSizing: "border-box"
                }}>
                  <span>S : {seriesNumber}</span>
                </div>
              </div>
            );
          }) : (
            <div style={{ color: "#fff", padding: 8, fontSize: 12 }}>No SC series</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SCSeriesPanel;
